<template>
  <div class="table__expansion">
    <div
      class="table__row"
      v-for="source of paginatedData(data.sourceIP)"
      :key="source.ip + source.port"
    >
      <div class="table__cell">
        <span v-if="selectable" class="mr-2">
          <input type="checkbox" :value="source.ip" v-model="selectedIPs" />
        </span>
        {{ source.ip }}
      </div>
      <div class="table__cell table__cell--desktop">
        Dest. port: {{ source.port }}
      </div>
      <div
        class="table__cell table__cell--mobile"
        v-tooltip.right="{
          content: 'Destination port',
          trigger: 'click'
        }"
      >
        <span>Dest ... :</span>
        <br />
        {{ source.port }}
      </div>
      <div class="table__cell">{{ source.count }}</div>
    </div>
    <div class="pagination" v-if="totalPages > 1">
      <div class="pagination-left">
        <div class="pagination-text">
          {{ paginationText(data.sourceIP.length) }}
        </div>
      </div>
      <div class="pagination-right">
        <ul class="pagination mb-0">
          <li
            class="page-item previous-page"
            :class="{ disabled: currentPage === 1 }"
          >
            <a
              @click="setPage(currentPage - 1)"
              :class="{ 'page-link': true, cursor: currentPage > 1 }"
              >&laquo;</a
            >
          </li>
          <li
            class="page-item next-page"
            :class="{
              disabled: currentPage === totalPages
            }"
          >
            <a
              @click="setPage(currentPage + 1)"
              v-bind:class="{
                'page-link': true,
                cursor: currentPage < totalPages
              }"
              >&raquo;</a
            >
          </li>
          <li>
            <div>
              <input type="number" v-model="pageNumber" />
              <button @click="setPage(pageNumber)" class="go-button">Go</button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'selectable'],
  data() {
    return {
      currentPage: 1,
      totalPages: 1,
      pageSize: 5,
      pageNumber: 1
    };
  },
  mounted() {
    this.totalPages = Math.ceil(this.data.sourceIP.length / this.pageSize);
  },
  computed: {
    paginatedData() {
      return data => {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = this.currentPage * this.pageSize;
        return JSON.parse(JSON.stringify(data.slice(start, end)));
      };
    },
    selectedIPs: {
      get() {
        return this.$store.getters['helpStore/selectedIPs'];
      },
      set(value) {
        this.$store.commit('helpStore/setSelectedIPs', value);
      }
    }
  },
  methods: {
    paginationText(length) {
      const start = (this.currentPage - 1) * this.pageSize + 1;
      let end = this.currentPage * this.pageSize;
      if (end > length) {
        end = length;
      }
      return `Showing ${start} to ${end} of ${length} entries`;
    },
    setPage(page) {
      page = Number(page);
      if (page < 1) {
        this.currentPage = 1;
      } else if (page > this.totalPages) {
        this.currentPage = this.totalPages;
      } else {
        this.currentPage = page;
      }
      this.pageNumber = this.currentPage;
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-text {
  @media screen and (max-width: 485px) {
    display: none;
  }
}

.pagination {
  input {
    border-radius: 0;
    border: 1px solid #979797;
  }
  button.go-button {
    border: none;
    border-radius: 0;

    &:hover {
      background-color: #4d4d4d;
    }

    &:focus {
      border: 1px solid #b3b3b3;
      outline: none;
    }
  }
  @media screen and (max-width: 485px) {
    padding-left: 0 !important;
    padding-right: 0 !important;

    li {
      font-size: 14px;
    }
    li:last-child {
      display: none;
    }
  }
}
li {
  &.disabled {
    cursor: not-allowed;
  }
}

.table__cell {
  &--desktop {
    @media screen and (max-width: 375px) {
      display: none;
    }
  }
  &--mobile {
    display: none;
    @media screen and (max-width: 375px) {
      display: inline-block;
    }

    span {
      white-space: nowrap;
    }
  }
}
</style>
